import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './services/auth-guard.service';
import { OfflineComponent } from './offline/offline.component';

const routes: Routes = [
	{
		path: '',
		redirectTo: 'splash',
		pathMatch: 'full'
	},
	{
		path: 'maintenance',
		loadChildren: () => import('./pages/maintenance/maintenance.module').then(m => m.MaintenancePageModule)
	},
	{
		path: 'offline',
		component: OfflineComponent
	},
	{
		path: 'splash',
		loadChildren: () => import('./pages/splash/splash.module').then(m => m.SplashPageModule)
	},
	{
		path: 'about',
		loadChildren: () => import('./pages/about/about.module').then(m => m.AboutPageModule)
	},
	{
		path: 'deals',
		loadChildren: () => import('./pages/deals/deals.module').then(m => m.DealsPageModule)
	},
	{
		path: 'auth',
		children: [
			{
				path: 'biometric',
				loadChildren: () => import('./pages/auth/biometric/biometric.module').then(m => m.BiometricPageModule)
			},
			{
				path: 'forgot',
				loadChildren: () => import('./pages/auth/forgot/forgot.module').then(m => m.ForgotPageModule)
			},
			{
				path: 'login',
				loadChildren: () => import('./pages/auth/login/login.module').then(m => m.LoginPageModule)
			},
			{
				path: 'register',
				loadChildren: () => import('./pages/auth/register/register.module').then(m => m.RegisterPageModule)
			},
			{
				path: 'welcome',
				loadChildren: () => import('./pages/auth/welcome/welcome.module').then(m => m.WelcomePageModule)
			},
		]
	},
	{
		path: 'confirm-email',
		loadChildren: () => import('./pages/auth/confirm-email/confirm-email.module').then(m => m.ConfirmEmailPageModule)
	},
	{
		path: 'account',
		canActivate: [AuthGuardService],
		children: [
			{
				path: 'connect',
				loadChildren: () => import('./pages/account/connect/connect.module').then(m => m.ConnectPageModule)
			},
			{
				path: 'connect/:id',
				loadChildren: () => import('./pages/account/connect/connect.module').then(m => m.ConnectPageModule)
			},
			{
				path: 'connected',
				loadChildren: () => import('./pages/account/connected/connected.module').then(m => m.ConnectedPageModule)
			},
			{
				path: 'logout',
				loadChildren: () => import('./pages/account/logout/logout.module').then(m => m.LogoutPageModule)
			},
			{
				path: 'settings',
				loadChildren: () => import('./pages/account/settings/settings.module').then(m => m.SettingsPageModule)
			},
		]
	},
	{
		path: 'pharmacy/:id',
		canActivateChild: [AuthGuardService],
		loadChildren: () => import('./pages/pharmacy/pharmacy.module').then(m => m.PharmacyPageModule)
	},
	{
		path: 'locations',
		loadChildren: () => import('./pages/locations/locations.module').then(m => m.LocationsPageModule)
	},
	{
		path: 'confirm-email',
		loadChildren: () => import('./pages/auth/confirm-email/confirm-email.module').then(m => m.ConfirmEmailPageModule)
	},
	{
		path: 'not-found',
		loadChildren: () => import('./pages/not-found/not-found.module').then(m => m.NotFoundPageModule)
	},
	{
		path: '**',
		redirectTo: 'not-found'
	},
]

@NgModule({
	imports: [
		RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
	],
	exports: [RouterModule]
})
export class AppRoutingModule { }
